import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { layoutConsts } from "theme";
import clsx from "clsx";

type SkewAxis = "x" | "y" | "both";

interface IUseStyleProps {
    axis: SkewAxis;
    skewAmount: number;
    skewChildren: boolean;
}

function getSkew(skewAmount: number, axis: SkewAxis) {
    if (axis === "y") return `skewY(${skewAmount}deg)`;
    if (axis === "x") return `skewX(${skewAmount}deg)`;

    return `skew(${skewAmount}deg)`;
}

const useStyles = (props: IUseStyleProps) =>
    makeStyles((theme: Theme) => {
        const { axis, skewAmount, skewChildren } = props;

        return createStyles({
            root: {
                transform: getSkew(skewAmount, axis),
            },
            childContainer: {
                transform: skewChildren ? undefined : getSkew(-skewAmount, axis),
            },
        });
    });

type IClasses = Partial<ReturnType<ReturnType<typeof useStyles>>>;

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    axis?: SkewAxis;
    skewAmount?: number;
    classes?: IClasses;
    skewChildren?: boolean;
}

export default function SkewedSection(props: IProps) {
    const {
        skewAmount = layoutConsts.defaultSkewDegrees,
        skewChildren = false,
        classes: overrideClasses,
        children,
        className,
        axis = "both",
        ...rest
    } = props;
    const classes = useStyles({ axis, skewAmount, skewChildren })();

    return (
        <div className={clsx(className, classes.root, overrideClasses?.root)} {...rest}>
            <div className={clsx(classes.childContainer, overrideClasses?.childContainer)}>
                {children}
            </div>
        </div>
    );
}
